import React from 'react'
import KeyFeatureComponent from '../../home/KeyFeatureComponent/KeyFeatureComponent'

function Apply_Now() {
  return (
    <>
    <KeyFeatureComponent />
    </>
  )
}

export default Apply_Now